import { useRef } from "react";
import { WatchTimeData } from "@types";
import courseApi from "@api/course";
import { useAppContext } from "@context/app";
import { useEmbedVideoAccessContext } from "./EmbedVideoAccessContext";

export const useEmbedVideoAccess = () => {
  const {
    user: { isLoggedIn },
  } = useAppContext();
  const { mutate, courseData } = useEmbedVideoAccessContext();

  const {
    product: { id },
    lessons,
  } = courseData;

  const theLesson =
    lessons?.find((lesson) => lesson.note === "openCourse") ||
    lessons?.[0] ||
    null;

  const watchedData = useRef<WatchTimeData>({
    lastWatchedTime: 0,
    watchedDuration: 0,
    lastWatchedPercent: 0,
  });

  const updateWatchTime = async (time: number, duration: number) => {
    if (!theLesson) return;
    try {
      if (watchedData.current.req) {
        watchedData.current.req.cancel();
      }
      watchedData.current.req = courseApi.updateWatchTime({
        duration: Math.round(duration),
        time: Math.round(time),
        lesson_id: String(theLesson.id),
        product_id: String(id),
      });
      await watchedData.current.req.fetch();
      const p = Math.max(Math.min(100, Math.round((time * 100) / duration)), 0);
      watchedData.current.lastWatchedPercent = Math.max(
        watchedData.current.lastWatchedPercent,
        p
      );
    } catch {
    } finally {
      watchedData.current.req = undefined;
    }
  };

  const timeUpdateHandler = async (time: number, duration: number) => {
    if (!isLoggedIn) return;
    const diff = time - watchedData.current.lastWatchedTime;
    if (diff <= 1 && diff > 0) {
      watchedData.current.watchedDuration +=
        time - watchedData.current.lastWatchedTime;
    }
    if (duration > 0 && watchedData.current.watchedDuration >= 30) {
      watchedData.current.watchedDuration = 0;
      await updateWatchTime(time, duration);
    }
    watchedData.current.lastWatchedTime = time;
  };

  const onEnd = async (time: number, duration: number) => {
    watchedData.current.watchedDuration = 0;
    await updateWatchTime(time, duration);
    watchedData.current.lastWatchedTime = time;
  };

  return {
    courseData,
    mutate,
    timeUpdateHandler,
    onEnd,
  };
};
